__turbopack_context__.v({
  "inner": "_8zbBla_inner",
  "text": "_8zbBla_text",
  "wrap": "_8zbBla_wrap",
});
